import React, { Component } from 'react'

class ImageUploadInput extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isEmpty: false,
            isExtFalse: false,
            file: null
        };
    }

    async validateInput() {
        if (!this.props.value) {
            await this.setState({ isEmpty: true })
            return false
        } else if (!this.lookIfNumber()) {
            await this.setState({ isEmpty: false, isExtFalse: true })
            return false
        } else {
            await this.setState({ isEmpty: false, isExtFalse: false })
            return true
        }
    }

    render() {
        return (
            <form onSubmit={this.onFormSubmit}>
                <input
                    className="inputfile" type="file" id={this.props.id} name="file"
                    onChange={e => this.props.onChange({ preventDefault: e.preventDefault, target: { value: e.target.files[0] } }, this.props.stateProp)}
                />
                <label for={this.props.id}>Choose a file</label>
                <span className="data-span-input">{this.props.value !== ""  && this.props.value !== undefined ? this.props.value.name : "No file choosen"}</span>
                {/*<button type="submit">Upload</button>*/}
            </form>
        )
    }
}

export default ImageUploadInput
